var linkedin = "//s3.amazonaws.com/edge-assets.lemonade.com/linkedin-342f8fb08d085d6a5e9c2a59bbc55f88.svg";

export { linkedin as default };
